import {
  createContext, useContext, useEffect, useMemo, useRef, useState,
} from 'react';
import io from 'socket.io-client';
import { API_URL } from '../config';

const WS_URL = API_URL;

export const WsContext = createContext({});

export const useSocket = () => useContext(WsContext);

const WsProvider = ({ children, namespace = '' }) => {
  const [socket, setSocket] = useState();
  const [socketConnected, setSocketConnected] = useState(false);
  const joinedRooms = useRef({});

  useEffect(() => {
    const inititateWebSocket = async () => {
      if (socket) return;
      const { idToken, orgId } = window.localStorage;
      const sckt = io(`${WS_URL}/${namespace}`, {
        auth: { idToken, orgId },
        secure: true,
      });

      sckt.on('connect', () => {
        setSocket(sckt);
        setSocketConnected(true);
        console.log('socket connected to', sckt.id);
        sckt.emit('join-room', { name: orgId }, (r) => {
          if (r.success) console.log('joined room', orgId);
          else console.log('failed join');
        });
      });

      sckt.on('reconnect', (attempt) => {
        setSocketConnected(true);
        console.log('reconnected to socket in attempt', attempt);
        if (socket && Object.keys(joinedRooms.current).length) {
          Object.keys(joinedRooms.current).forEach(((r) => {
            console.log('rejoing socket room', r);
            sckt.emit('join-room', { name: r });
          }));
        }
      });

      sckt.on('disconnect', () => {
        setSocketConnected(false);
        console.log('socket disconnected!');
        sckt.off('log');
        sckt.off('UDPlog');
      });

      sckt.on('error', (err) => {
        setSocketConnected(false);
        console.error('Error connecting to websocket', err.message);
      });

      sckt.on('update', (data) => console.log('socket update:', data));
      sckt.on('connect_error', (err) => console.error('socket connect_error:', err));
      sckt.on('connect_failed', (err) => console.error('socket connect_failed:', err));
    };
    inititateWebSocket();
  }, []);

  const state = useMemo(() => ({ socket, socketConnected }), [socket, socketConnected]);

  return (
    <WsContext.Provider value={state}>
      {children}
    </WsContext.Provider>
  );
};

export default WsProvider;
